import * as HttpService from "./http.service";
import * as URL from "./url.service";

export const createEmployeeAvailabiltyNotification = (notification) => {
    return HttpService.postWithAuth(URL.CREATE_EMPLOYEE_AVAILABILTY_NOTIFICATION_URL, notification);
}
export const getAllNotifications = ({ limit, offset }) => {
    return HttpService.getWithAuth(URL.GET_ALL_NOTIFICATIONS_URL({ limit, offset }));
}
export const updateNotification = (id) =>{
    return HttpService.putWithAuth(URL.UPDATE_NOTIFICATION_URL(id));
}